<template>
    <div class="app-inner">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit('ruleForm')"
            >
               保存
           </el-button>
            </div>
                <div class="edit-from">
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-picture-fill"></i>  封面图片
            </div>
        </div>
        <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules">
                  <el-form-item label="内容封面：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >
                      <span style="color:#f56c6c">建议尺寸：328*440</span>；
                    </div>
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                     <div class="public-tit flex align-cen" style="margin-bottom:20px">
                    <div class="public-tit-list">
                        <i class="icon-al-info-circle-fill"></i>  详情内容
                    </div>
                </div>
                <el-form-item label="详情内容类型：" prop="contentType">
                    <el-radio v-model="form.contentType" label="1" >官网内容</el-radio>
                    <el-radio v-model="form.contentType" label="2">配置内容</el-radio>
                </el-form-item>
                <div v-if="form.contentType == 1">
                     <el-form-item label="官网内容类型：" :prop="form.contentType == 1 ? 'websiteType' : ''">
                    <el-radio v-model="form.websiteType" label="1"  @change="changeTouch">产品内容</el-radio>
                    <el-radio v-model="form.websiteType" label="2" @change="changeTouch">项目案例</el-radio>
                    <el-radio v-model="form.websiteType" label="3" @change="changeTouch">解决方案</el-radio>
                    <el-radio v-model="form.websiteType" label="4" @change="changeTouch">新闻动态</el-radio>
                </el-form-item>
                </div>
        </el-form>
                <div v-if="form.contentType == 1">
                       <div class="public-tit flex align-cen">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  关联内容
                    </div>
                        <div class="mft public-btn-small">
                            <div class="public-btn-small-primary" @click="openBl">
                                关联{{getType(form.websiteType,0) || '内容'}}          
                            </div>
                        </div>
                </div>
                   <el-table
                    :data="multipleSelection"
                    ref="multipleTable"
                    tooltip-effect="dark"
                    style="width: 100%;margin-top:16px"
                    border
                    id='mytable'
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                            <el-table-column :label="`${getType(form.websiteType,1)}ID`" align="center" prop="id">
                            </el-table-column>
                            <el-table-column :label="`${getType(form.websiteType,1)}名称`" align="center" :prop="form.websiteType==1 ? 'appName' : 'name'">
                            </el-table-column>
                                <el-table-column label="操作" align="center"
                                >
                             <el-button type="text" size="small"  style="color:red" @click="openBl">更换</el-button>
                              <el-button type="text" size="small"  style="color:red" @click="changeTouch">删除</el-button>
                            </el-table-column>
                  </el-table>
                </div>
                <div v-if="form.contentType == 2">
                                   <div class="AppContent">
                  <div class="moreCanvas"
                     v-for="(item,index) in platformAppContentList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                     <div class="businessList-filter-list flex align-cen">
                            <div class="fl-le flex align-cen">
                    <div class="label">标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                       <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subtitle" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                     </div>
              <div class="quillsFLex " style="margin-top:20px;padding:20px 50px">
                <el-input
                        type="textarea"
                        rows="10"
                        placeholder="请输入内容"
                        :maxlength="500"
                        show-word-limit
                        v-model="item.content">
                        </el-input>
                </div>
                  </div>
               </div>
                </div>
                </div>
                 <el-dialog
                    :title="`选择${getType(form.websiteType)}`"
                    :visible.sync="centerDialogVisible"
                    width="80%"
                    :append-to-body="true"
                    center
                    v-if="centerDialogVisible"
                    >
                      <div class="forminfo">
                    <component :is="currentComponent" v-if="form.websiteType" :ref="currentComponent" :authType = '1' @sendStatus="classSelect"></component> 
                    </div>
                     </el-dialog>
        </div>
</template>
<script>
import appTemplate from "@/views/Application/index.vue"; //将应用列表页面作为组件使用
import caseTemplate from "@/views/HomeWebsite/Case/index.vue"; //将项目案例页面作为组件使用
import souTemplate from "@/views/HomeWebsite/Solution/index.vue"; //将解决方案页面作为组件使用
import newTemplate from "@/views/HomeWebsite/News/index.vue"; //将新闻动态页面作为组件使用
export default {
    name:'touchDetail',
    components:{
        appTemplate,
        caseTemplate,
        souTemplate,
        newTemplate,
    },
    data () {
        return {
            platformAppContentList:[
                {
                    title:'',
                    subtitle:'',
                    content:'',
                }
            ],
            multipleSelection:[],
            currentComponent:'appTemplate',
            propArr:{},
            propList:{},
            loading:false,  
            touchId:'',
            headers:{},
            centerDialogVisible:false,
            oploadDialogVisible:false,
            uploadBoolean:false,
            form:{
                logo:'',
                contentType:'',
                websiteType:'1',
                detailId:'',
                detailName:'',
                contentList:[],
                detailVO:'',
                touchId:'',
            },
            rules:{
                logo:[{ required: true, message: '请上传内容封面图', trigger: 'blur' }],
                contentType:[{ required: true, message: '请选择详情内容类型', trigger: 'change' }],
                websiteType:[{ required: true, message: '请选择官网内容类型', trigger: 'change' }]
            }   
           }
    },
    created () {  
         let token = this.$locaStorage.setAge().get('token')
          if(token){
            this.headers = {
                'Authorization': token
            }
        }
        let decryptQuery=this.$base64.decode(this.$route.query.arr); // 解密
         this.propArr = JSON.parse(decryptQuery)
        
         this.propList = this.propArr[this.$route.query.index]
                  this.form = this.propList
        if(this.$route.query.id){
        let touchId = this.$route.query.id ? this.$base64.decode(this.$route.query.id) : ''
         this.touchId = JSON.parse(touchId)
         this.form = this.propList
        }
         if(this.form.contentType == 2){

            this.platformAppContentList = this.propList.contentList
         }else{
           if(this.form.detailId){
             this.multipleSelection = [
                {
                    id:this.propList.detailId,
                }
            ]
             this.multipleSelection[0][this.propList.websiteType == 1 ? 'appName' : 'name'] = this.propList.detailName
           }else{
            this.multipleSelection = []
           }
         }
    },
    methods: {
               // 删除分类
        deletCanvas(data){
            let arr = []
            arr.push(data)
        let delet= this.platformAppContentList.filter(item=>!arr.some(ele=>ele ===item)) 
       this.platformAppContentList = delet
        this.nowIndex == 0 ?  this.nowIndex = 0 : this.nowIndex = this.nowIndex -1
        },
                    // 添加分类
        addCanvas(index){
            if(index>=0){
                this.nowIndex=index
            }else{
                this.nowIndex=0
            }
            this.platformAppContentList.push({
                title:'',
                subtitle:'',
                content:'',
            })
        },
               // 子组件触发的方法
        emitFun(val,index){
            this.platformAppContentList[index].content = val
        },
        // 官网内容切换
        changeTouch(){
            this.multipleSelection = []
            this.form.detailId = ''
            this.form.detailName = ''
        },
        // 打开关联模版
        openBl(){
            let temType = ['','appTemplate','caseTemplate','souTemplate','newTemplate']
            this.centerDialogVisible = true;
           this.currentComponent = temType[this.form.websiteType]
        },
         //  选择应用
        classSelect(val){
            console.log(val)
            this.multipleSelection = []
            this.multipleSelection.push(val)
            this.form.detailId = val.id
            this.form.detailName = this.form.websiteType == 1 ? val.appName : val.name
            this.centerDialogVisible = false
        },
          getType(type,nametype){
            let actionTypelanes = {
                1:nametype == 1 ? '产品': '产品内容',
                2:nametype== 1 ? '案例' : '项目案例',
                3:'解决方案',
                4:nametype== 1 ? '新闻' : '新闻动态',
            }
            return actionTypelanes[type] || ''
        },
         // 图片放大
         oploadImgPre(){
            this.oploadDialogVisible = true
            },
        oploadImgDel(){
            this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
        },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
        // 返回
        reback(){
                  this.$confirm('确认返回？返回后编辑的数据将不做保存处理，请谨慎操作。', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                   this.$router.push(
                            {
                            name:'addTouch',
                            query:{
                                id:this.touchId,
                                parms:this.$route.query.parms,
                                arr:this.$route.query.arr
                            }
                            }
                        )
                    })
             
        },
        onSubmit(formName){
            if(this.form.contentType == 1 && !this.form.detailId) return this.$util.Notifi('请选择关联内容','error','fa-exclamation-circle');
            this.form.contentList = this.platformAppContentList
              this.$refs[formName].validate((valid) => { 
                if(valid){
                    this.propArr[this.$route.query.index] = this.form
                     this.$router.push(
                        {
                        name:'addTouch',
                        query:{
                            id:this.touchId,
                            parms:this.$route.query.parms, //加密参数
                            index:this.$route.query.index,
                            arr:this.$base64.encode(JSON.stringify(this.propArr))
                        }
                        }
                        )
                    //  this.commentBness(params,method)
                }
              })
        }
    },
}
</script>
<style lang="scss" scoped>
.edit-from{
    margin-bottom: 44px;
}
  .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         }
              .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
           ::v-deep{
                            .quillsFLex{
      .quillTemplate{
        margin-right: 10px !important;
      }
    }
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 328px;
    height:440px;
    line-height: 440px;
    text-align: center;
  }
  
  .avatar {
    width: 328px;
    height: 440px;
    display: block;
  }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
  }
</style>